import { Routes } from '@angular/router';
import { CategoryFormComponent } from './components/organisms/category-form/category-form.component';
import { AtlasComponent } from './components/pages/atlas/atlas.component';
import { DataBackendComponent } from './components/pages/data-backend/data-backend.component';
import { DashboardComponent } from './components/pages/dashboard/dashboard.component';
import { AccountComponent } from './components/organisms/account/account.component';
import { RoleDatalayerTypesComponent } from './components/molecules/role-datalayer-types/role-datalayer-types.component';
import { RoleBookmarksComponent } from './components/molecules/role-bookmarks/role-bookmarks.component';
import { RoleToolsComponent } from './components/molecules/role-tools/role-tools.component';
import { RolePoisComponent } from './components/molecules/role-pois/role-pois.component';
import { RoleIndicatorsComponent } from './components/molecules/role-indicators/role-indicators.component';
import { EntityAdderComponent } from './components/organisms/entity-adder/entity-adder.component';
import { ConfigurationComponent } from './components/organisms/configuration/configuration.component';
import { IndicatorsComponent } from './components/organisms/indicators/indicators.component';
import { UserManagementComponent } from './components/organisms/user-management/user-management.component';
import { UserListComponent } from './components/molecules/user-list/user-list.component';
import { RoleListComponent } from './components/molecules/role-list/role-list.component';
import { LoginComponent } from './components/organisms/login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { WorkspaceFormComponent } from './components/organisms/workspace-form/workspace-form.component';
import { WorkspaceListComponent } from './components/organisms/workspace-list/workspace-list.component';
import { UserFormComponent } from './components/organisms/user-form/user-form.component';
import { RoleFormComponent } from './components/organisms/role-form/role-form.component';
import { IndicatorFormComponent } from './components/organisms/indicator-form/indicator-form.component';
import { ColorsetFormComponent } from './components/organisms/colorset-form/colorset-form.component';
import { TagFormComponent } from './components/organisms/tag-form/tag-form.component';
import { DataLayerTypeFormComponent } from './components/organisms/data-layer-type-form/data-layer-type-form.component';
import { PoiDataLayerTypeFormComponent } from './components/organisms/poi-data-layer-type-form/poi-data-layer-type-form.component';
import { DataLayerFormComponent } from './components/organisms/data-layer-form/data-layer-form.component';
import { BookmarkAdministrationComponent } from './components/organisms/bookmark-administration/bookmark-administration.component';
import { BookmarkFormComponent } from './components/organisms/bookmark-form/bookmark-form.component';
import { BookmarkCategoryFormComponent } from './components/organisms/bookmark-category-form/bookmark-category-form.component';
import { ImportExportComponent } from './components/organisms/import-export/import-export.component';
import { ImportExportIndicatorsComponent } from './components/organisms/import-export-indicators/import-export-indicators.component';
import { ImportExportDataComponent } from './components/organisms/import-export-data/import-export-data.component';
import { ImportExportGeodataComponent } from './components/organisms/import-export-geodata/import-export-geodata.component';
import { ImportExportPoiComponent } from './components/organisms/import-export-poi/import-export-poi.component';
import { DataLayerTypeOverlayComponent } from './components/organisms/data-layer-type-overlay/data-layer-type-overlay.component';
import { IndicatorDataFormComponent } from './components/organisms/indicator-data-form/indicator-data-form.component';
import { StoryAdministrationComponent } from './components/organisms/story-administration/story-administration.component';
import { StoryFormComponent } from './components/organisms/story-form/story-form.component';
import { TopicAdministrationComponent } from './components/organisms/topic-administration/topic-administration.component';
import { TopicFormComponent } from './components/organisms/topic-form/topic-form.component';
import { HistoryListComponent } from './components/organisms/history-list/history-list.component';
import { BulkActionsComponent } from './components/organisms/bulk-actions/bulk-actions.component';
import { BulkActionComponent } from './components/molecules/bulk-action/bulk-action.component';
import { ColorsetAdministrationComponent } from './components/molecules/colorset-administration/colorset-administration.component';
import { IndicatorPoolComponent } from './components/organisms/indicator-pool/indicator-pool.component';
import { InitialPasswordComponent } from './components/pages/single/initial-password/initial-password.component';
import { permissionGuard } from './guards/permission.guard';
import { ConfigurationAtlasComponent } from './components/molecules/configuration-atlas/configuration-atlas.component';
import { ConfigurationMapComponent } from './components/molecules/configuration-map/configuration-map.component';
import { ConfigurationChartComponent } from './components/molecules/configuration-chart/configuration-chart.component';
import { ConfigurationTagsComponent } from './components/molecules/configuration-tags/configuration-tags.component';
import { ConfigurationComparisonValuesComponent } from './components/molecules/configuration-comparison-values/configuration-comparison-values.component';
import { ComparisonValueFormComponent } from './components/organisms/comparison-value-form/comparison-value-form.component';
import { DistrictReportComponent } from './components/organisms/district-report/district-report.component';
import { CommuneFormComponent } from './components/organisms/commune-form/commune-form.component';
import { CommuneListComponent } from './components/organisms/commune-list/commune-list.component';
import { HelpListComponent } from './components/organisms/help-list/help-list.component';
import { HelpFormComponent } from './components/organisms/help-form/help-form.component';
import { ConfigurationLandingpageComponent } from './components/molecules/configuration-landingpage/configuration-landingpage.component';
import { NotificationListComponent } from './components/organisms/notification-list/notification-list.component';
import { NotificationFormComponent } from './components/organisms/notification-form/notification-form.component';
import { PublishManagerComponent } from './components/organisms/publish-manager/publish-manager.component';
import { ConfigurationNavigationComponent } from './components/molecules/configuration-navigation/configuration-navigation.component';
import { routeContextGuard } from './guards/route-context.guard';
import { ForgetPasswordComponent } from './components/molecules/forget-password/forget-password.component';
import { ImagePoolComponent } from './components/organisms/image-pool/image-pool.component';
import { ImageFormComponent } from './components/organisms/image-form/image-form.component';
import { OverviewTableIndicatorComponent } from './components/organisms/overview-table-indicator/overview-table-indicator.component';
import { GuestLinkGuard } from './guards/guest-link.guard';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';
import { GuestLinkListComponent } from './components/organisms/guest-link-list/guest-link-list.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'passwort-vergessen',
    component: ForgetPasswordComponent,
  },
  {
    path: 'initiales-passwort/:id',
    component: InitialPasswordComponent,
  },
  {
    path: 'neues-passwort/:token',
    component: InitialPasswordComponent,
  },
  {
    path: 'neues-passwort',
    component: InitialPasswordComponent,
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard], // Protect all child routes via canActivateChild
    component: DashboardComponent,
    data: {
      context: 'dataBackend',
    },
    children: [
      {
        path: 'kommunen',
        component: CommuneListComponent,
        outlet: 'overlay',
        data: {
          sidebarId: 'commune-administration',
          entityType: 'Commune',
        },
        children: [
          {
            path: ':id',
            component: CommuneFormComponent,
            outlet: 'bearbeiten',
            data: {
              overlayText: 'Kommune',
              entityType: 'Commune',
              sidebarId: 'commune-administration',
            },
          },
          {
            path: ':commune/user/:id',
            component: UserFormComponent,
            outlet: 'bearbeiten',
            data: {
              overlayText: 'Nutzer:in',
              entityType: 'User',
              sidebarId: 'commune-administration',
            },
          },
        ],
      },
      {
        path: 'dokumentation',
        component: HelpListComponent,
        outlet: 'overlay',
        data: {
          sidebarId: 'help-administration',
          entityType: 'Help',
        },
        children: [
          {
            path: ':id',
            component: HelpFormComponent,
            outlet: 'bearbeiten',
            data: {
              overlayText: 'Dokumentation',
              entityType: 'Help',
              sidebarId: 'help-administration',
            },
          },
        ],
      },
      {
        path: 'benachrichtigungen',
        component: NotificationListComponent,
        outlet: 'overlay',
        data: {
          sidebarId: 'notification-administration',
          entityType: 'Notification',
        },
        children: [
          {
            path: ':id',
            component: NotificationFormComponent,
            outlet: 'bearbeiten',
            data: {
              overlayText: 'Benachrichtigungen',
              entityType: 'Notification',
              sidebarId: 'notification-administration',
            },
          },
        ],
      },
    ],
  },
  {
    path: 'atlas-intern',
    canActivate: [routeContextGuard, AuthGuard],
    canActivateChild: [AuthGuard], // Protect all child routes via canActivateChild
    component: AtlasComponent,
    data: {
      context: 'atlasInternal',
    },
    children: [
      {
        path: 'ansicht/:id',
        component: AtlasComponent,
        canActivate: [unsavedChangesGuard],
        data: {
          entityType: 'Bookmark',
          context: 'atlasInternal',
        },
      },
      {
        path: 'bericht/:id',
        component: AtlasComponent,
        canActivate: [unsavedChangesGuard],
        data: {
          entityType: 'Story',
          context: 'atlasInternal',
        },
      },
      {
        //path: ':id',
        path: ':id/:key',
        outlet: 'reports',
        component: DistrictReportComponent,
        data: {
          entityType: 'Report',
          context: 'atlasInternal',
        },
      },
    ],
  },
  {
    path: 'atlas/:slug',
    canActivate: [routeContextGuard],
    component: AtlasComponent,
    children: [
      {
        path: 'ansicht/:id',
        component: AtlasComponent,
        canActivate: [unsavedChangesGuard],
        data: {
          entityType: 'Bookmark',
          context: 'atlasExternal',
        },
      },
      {
        path: 'bericht/:id',
        component: AtlasComponent,
        canActivate: [unsavedChangesGuard],
        data: {
          entityType: 'Story',
          context: 'atlasExternal',
        },
      },
      {
        path: 'gast-ansicht/:id',
        component: AtlasComponent,
        canActivate: [GuestLinkGuard],
        data: {
          context: 'guestView',
          entityType: 'Bookmark',
        },
      },
      {
        path: 'gast-bericht/:id',
        component: AtlasComponent,
        canActivate: [GuestLinkGuard],
        data: {
          context: 'guestView',
          entityType: 'Story',
        },
      },
      {
        path: ':id/:key',
        outlet: 'reports',
        component: DistrictReportComponent,
        data: {
          entityType: 'Report',
          context: 'atlasExternal',
        },
      },
    ],
    data: {
      context: 'atlasExternal',
      slug: ':slug',
    },
  },
  {
    path: 'data-backend',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard], // Protect all child routes via canActivateChild
    component: DataBackendComponent,
    data: {
      context: 'dataBackend',
    },
    children: [
      {
        path: 'themen/:id/',
        redirectTo: 'themen/:id/general',
      },
      {
        path: 'themen/:id',
        component: TopicFormComponent,
        outlet: 'bearbeiten',
        data: {
          overlayText: 'Thema',
          entityType: 'Topic',
          sidebarId: 'root',
        },
      },
      {
        path: 'lesezeichen/:id',
        component: BookmarkFormComponent,
        outlet: 'bearbeiten',
        data: {
          overlayText: 'Ansichten',
          entityType: 'Bookmark',
          sidebarId: 'root',
        },
      },
      {
        path: 'farbsets/:id',
        component: ColorsetFormComponent,
        outlet: 'bearbeiten',
        data: {
          overlayText: 'Farbset',
          entityType: 'Colorset',
          sidebarId: 'root',
        },
      },
      {
        path: 'indikatoren/:id/:tab',
        component: IndicatorFormComponent,
        outlet: 'bearbeiten',
        children: [
          {
            path: ':id/:tab',
            component: IndicatorFormComponent,
            outlet: 'auspraegung',
            data: {
              cancelLevel: 1,
              overlayText: 'Ausprägung',
              entityType: 'Indicator',
              excludeFromRouteSelection: true,
            },
          },
        ],
        data: {
          overlayText: 'Indikator',
          entityType: 'Indicator',
          sidebarId: 'root',
        },
      },
      {
        path: 'raum/:id',
        component: DataLayerTypeFormComponent,
        outlet: 'bearbeiten',
        data: {
          overlayText: 'Raum',
          entityType: 'DataLayerType',
          sidebarId: 'root',
        },
      },
      {
        path: 'stories/:id',
        component: StoryFormComponent,
        outlet: 'bearbeiten',
        data: {
          overlayText: 'Bericht',
          entityType: 'Story',
          sidebarId: 'root',
        },
      },
      {
        path: 'poi/:id',
        component: PoiDataLayerTypeFormComponent,
        outlet: 'bearbeiten',
        data: {
          overlayText: 'Standorte',
          entityType: 'DataLayerType',
          sidebarId: 'root',
        },
      },
      {
        path: 'ebene/:id',
        component: DataLayerTypeOverlayComponent,
        outlet: 'bearbeiten',
        data: {
          entityType: 'DataLayerType',
          sidebarId: 'datalayer-administration',
        },
        children: [
          {
            path: ':id',
            component: DataLayerFormComponent,
            outlet: 'jahr',
            data: {
              entityType: 'DataLayerType',
              overlayText: 'Jahr',
              sidebarId: 'datalayer-administration',
            },
          },
        ],
      },
      {
        path: 'data/:id',
        component: IndicatorDataFormComponent,
        outlet: 'bearbeiten',
        data: {
          entityType: 'IndicatorData',
          overlayText: 'Daten',
          sidebarId: 'indicator-data-administration',
          cancelLevel: 1,
        },
      },
      {
        path: 'indikator/:id/:tab',
        component: IndicatorFormComponent,
        outlet: 'bearbeiten',
        data: {
          overlayText: 'Indikator',
          entityType: 'Indicator',
          sidebarId: 'indicator-root',
          cancelLevel: 1,
        },
        children: [
          {
            path: ':id/:tab',
            component: IndicatorFormComponent,
            outlet: 'auspraegung',
            data: {
              overlayText: 'Ausprägung',
              entityType: 'Indicator',
              excludeFromRouteSelection: true,
              cancelLevel: 1,
            },
          },
        ],
      },
      {
        path: 'lesezeichen',
        component: BookmarkAdministrationComponent,
        canActivate: [permissionGuard],
        data: { permission: 'bookmarks' },
        outlet: 'overlay',
        children: [
          {
            path: ':id',
            component: BookmarkFormComponent,
            outlet: 'bearbeiten',
            data: {
              overlayText: 'Ansichten',
              entityType: 'Bookmark',
              sidebarId: 'bookmark-administration',
            },
          },
          {
            path: 'bereich/:id',
            component: BookmarkCategoryFormComponent,
            outlet: 'bearbeiten',
            data: {
              overlayText: 'Themenbereich',
              entityType: 'BookmarkCategory',
              sidebarId: 'bookmark-administration',
            },
          },
        ],
      },
      {
        path: 'berichte',
        component: StoryAdministrationComponent,
        canActivate: [permissionGuard],
        data: { permission: 'stories' },
        outlet: 'overlay',
        children: [
          {
            path: ':id',
            component: StoryFormComponent,
            outlet: 'bearbeiten',
            data: {
              overlayText: 'Bericht',
              entityType: 'Story',
              sidebarId: 'story-administration',
            },
          },
        ],
      },
      {
        path: 'farbsets',
        component: ColorsetAdministrationComponent,
        outlet: 'overlay',
        canActivate: [permissionGuard],
        data: { permission: 'colorsets' },
        children: [
          {
            path: ':id',
            component: ColorsetFormComponent,
            outlet: 'bearbeiten',
            data: {
              overlayText: 'Farbset',
              entityType: 'Colorset',
              sidebarId: 'colorset-administration',
            },
          },
        ],
      },
      {
        path: 'themen',
        component: TopicAdministrationComponent,
        canActivate: [permissionGuard],
        data: { permission: 'themes' },
        outlet: 'overlay',
        children: [
          {
            path: ':id',
            outlet: 'bearbeiten',
            redirectTo: ':id/general',
          },
          {
            path: ':id/:tab',
            component: TopicFormComponent,
            outlet: 'bearbeiten',
            data: {
              overlayText: 'Thema',
              entityType: 'Topic',
              sidebarId: 'topic-administration',
            },
          },
        ],
      },
      {
        path: 'historie',
        component: HistoryListComponent,
        canActivate: [permissionGuard],
        data: { permission: 'history' },
        outlet: 'overlay',
      },
      {
        path: 'neu',
        component: EntityAdderComponent,
        outlet: 'overlay',
        canActivate: [permissionGuard],
        data: { permission: 'entityAdder' },
        children: [
          {
            path: 'raum/:id',
            component: DataLayerTypeFormComponent,
            outlet: 'panel',
            data: {
              overlayText: 'Raum',
              entityType: 'DataLayerType',
              //sidebarId: 'topic-administration',
            },
          },
          {
            path: 'poi/:id',
            component: PoiDataLayerTypeFormComponent,
            outlet: 'panel',
            data: {
              overlayText: 'Standorte',
              entityType: 'DataLayerType',
              //sidebarId: 'topic-administration',
            },
          },
          {
            path: 'jahr/:id',
            component: DataLayerFormComponent,
            outlet: 'panel',
            data: {
              overlayText: 'Datenschicht',
              entityType: 'DataLayer',
              //sidebarId: 'topic-administration',
            },
          },
          {
            path: 'farbset/:id',
            component: ColorsetFormComponent,
            outlet: 'panel',
            data: {
              overlayText: 'Farbset',
              entityType: 'Colorset',
              //sidebarId: 'topic-administration',
            },
          },
          {
            path: 'schlagwort/:id',
            component: TagFormComponent,
            outlet: 'panel',
            data: {
              overlayText: 'Schlagwort',
              entityType: 'Tag',
              //sidebarId: 'topic-administration',
            },
          },
          {
            path: 'indikator/:id/:tab',
            component: IndicatorFormComponent,
            outlet: 'panel',
            data: {
              overlayText: 'Indikator',
              entityType: 'Indicator',
              //sidebarId: 'topic-administration',
            },
            children: [
              {
                path: ':id/:tab',
                component: IndicatorFormComponent,
                outlet: 'auspraegung',
                data: {
                  overlayText: 'Ausprägung',
                  entityType: 'Indicator',
                  cancelLevel: 1,
                  //sidebarId: 'topic-administration',
                },
              },
            ],
          },
          {
            path: 'workspaces/:id/:tab',
            outlet: 'panel',
            component: WorkspaceListComponent,
            children: [
              {
                path: ':id',
                component: WorkspaceFormComponent,
                outlet: 'bearbeiten',
                data: {
                  overlayText: 'Arbeitsbereich',
                  entityType: 'Workspace',
                  sidebarId: 'workspace-administration',
                },
              },
            ],
          },
          {
            path: 'indikatoren-bereich/:id',
            component: CategoryFormComponent,
            outlet: 'panel',
            data: {
              overlayText: 'Ordner',
              entityType: 'Category',
            },
          },
          {
            path: 'workspace/:id',
            component: WorkspaceFormComponent,
            outlet: 'panel',
            data: {
              overlayText: 'Arbeitsbereich',
              entityType: 'Workspace',
              sidebarId: 'workspace-administration',
            },
          },
          {
            path: 'lesezeichen/:id',
            component: BookmarkFormComponent,
            outlet: 'panel',
            data: {
              overlayText: 'Ansichten',
              entityType: 'Bookmark',
            },
          },
          {
            path: 'lesezeichenbereich/:id',
            component: BookmarkCategoryFormComponent,
            outlet: 'panel',
            data: {
              overlayText: 'Themenbereich',
              entityType: 'BookmarkCategory',
            },
          },
          {
            path: 'vergleichswert/:id',
            component: ComparisonValueFormComponent,
            outlet: 'panel',
            data: {
              overlayText: 'Vergleichswert',
              entityType: 'ComparisonValue',
            },
          },
          {
            path: 'thema/:id/:tab',
            component: TopicFormComponent,
            outlet: 'panel',
            data: {
              overlayText: 'Thema',
              entityType: 'Topic',
              sidebarId: 'topic-administration',
            },
          },
          {
            path: 'rolle/:id',
            component: RoleFormComponent,
            outlet: 'panel',
            data: {
              overlayText: 'Rolle',
              entityType: 'Role',
              //sidebarId: 'topic-administration',
            },
          },
        ],
      },
      {
        path: 'nutzerverwaltung',
        component: UserManagementComponent,
        outlet: 'overlay',
        canActivate: [permissionGuard],
        data: { permission: 'userManagement' },
        children: [
          {
            path: 'kommune',
            component: CommuneFormComponent,
            outlet: 'panel',
          },
          {
            path: 'nutzer',
            component: UserListComponent,
            outlet: 'panel',
            children: [
              {
                path: ':id',
                component: UserFormComponent,
                outlet: 'bearbeiten',
                data: {
                  overlayText: 'Nutzer:in',
                  entityType: 'User',
                  sidebarId: 'user-administration',
                },
              },
            ],
          },
          {
            path: 'rollen',
            component: RoleListComponent,
            outlet: 'panel',
            children: [
              {
                path: ':id',
                component: RoleFormComponent,
                outlet: 'bearbeiten',
                data: {
                  overlayText: 'Rolle',
                  entityType: 'Role',
                  sidebarId: 'role-administration',
                },
              },
            ],
          },
          {
            path: 'workspaces/:tab',
            outlet: 'panel',
            component: WorkspaceListComponent,
            children: [
              {
                path: ':id',
                component: WorkspaceFormComponent,
                outlet: 'bearbeiten',
                data: {
                  overlayText: 'Arbeitsbereich',
                  entityType: 'Workspace',
                  sidebarId: 'workspace-administration',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'indikatoren-bericht',
        component: OverviewTableIndicatorComponent,
        outlet: 'overlay',
        data: {
          sidebarId: 'indicator-overview',
          entityType: 'Indicator',
        },
      },
      {
        path: 'konfiguration',
        canActivate: [permissionGuard],
        data: { permission: 'config', sidebarId: 'config' },
        component: ConfigurationComponent,
        outlet: 'overlay',
        children: [
          {
            path: 'atlas',
            component: ConfigurationAtlasComponent,
            outlet: 'panel',
          },
          {
            path: 'startseite',
            component: ConfigurationLandingpageComponent,
            outlet: 'panel',
          },
          {
            path: 'navigation',
            component: ConfigurationNavigationComponent,
            outlet: 'panel',
          },
          {
            path: 'links',
            component: GuestLinkListComponent,
            outlet: 'panel',
            children: [
              {
                path: ':id',
                component: BookmarkFormComponent,
                outlet: 'bearbeiten',
                data: {
                  permission: 'bookmark-administration',
                  action: 'edit',
                  overlayText: 'Ansicht',
                  entityType: 'Bookmark',
                  sidebarId: 'bookmark-guest-link',
                },
              },
            ],
          },
          {
            path: 'karte',
            component: ConfigurationMapComponent,
            outlet: 'panel',
          },
          {
            path: 'diagramme',
            component: ConfigurationChartComponent,
            outlet: 'panel',
          },
          {
            path: 'schlagworte',
            component: ConfigurationTagsComponent,
            outlet: 'panel',
            children: [
              {
                path: ':id',
                component: TagFormComponent,
                outlet: 'bearbeiten',
                data: {
                  permission: 'tags',
                  action: 'edit',
                  overlayText: 'Schlagwort',
                  entityType: 'Tag',
                  sidebarId: 'tag-administration',
                },
              },
            ],
          },
          {
            path: 'vergleichswerte',
            component: ConfigurationComparisonValuesComponent,
            outlet: 'panel',
            children: [
              {
                path: ':id',
                component: ComparisonValueFormComponent,
                outlet: 'bearbeiten',
                data: {
                  permission: 'comparison-values',
                  action: 'edit',
                  overlayText: 'Vergleichswert',
                  entityType: 'ComparisonValue',
                  sidebarId: 'comparison-value-administration',
                },
              },
            ],
          },
          {
            path: 'bilder',
            component: ImagePoolComponent,
            outlet: 'panel',
            children: [
              {
                path: ':id',
                component: ImageFormComponent,
                outlet: 'bearbeiten',
                data: {
                  permission: 'images',
                  action: 'edit',
                  overlayText: 'Bilder',
                  entityType: 'Image',
                  sidebarId: 'image-administration',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'indikatoren',
        component: IndicatorsComponent,
        canActivate: [permissionGuard],
        outlet: 'overlay',
        data: {
          sidebarId: 'indicator-tree',
          permission: 'indicators',
          helpKeywords: ['indikator'],
        },
        children: [
          {
            path: 'indikator/:id/:tab',
            component: IndicatorFormComponent,
            canActivate: [permissionGuard],
            outlet: 'bearbeiten',
            data: {
              permission: 'indicators',
              action: 'edit',
              overlayText: 'Indikator',
              entityType: 'Indicator',
              sidebarId: 'indicator-tree',
            },
            children: [
              {
                path: ':id/:tab',
                component: IndicatorFormComponent,
                outlet: 'auspraegung',
                data: {
                  cancelLevel: 1,
                  overlayText: 'Ausprägung',
                  entityType: 'Indicator',
                  sidebarId: 'indicator-tree',
                  excludeFromRouteSelection: true,
                },
              },
            ],
          },
          {
            path: 'bereich/:id',
            component: CategoryFormComponent,
            outlet: 'bearbeiten',
            data: {
              action: 'edit',
              overlayText: 'Ordner',
              entityType: 'Category',
              sidebarId: 'indicator-tree',
            },
          },
        ],
      },
      {
        path: 'vorlagen',
        component: IndicatorPoolComponent,
        canActivate: [permissionGuard],
        data: { permission: 'pool' },
        outlet: 'overlay',
      },
      {
        path: 'veröffentlichung',
        component: PublishManagerComponent,
        canActivate: [permissionGuard],
        data: { permission: 'publish' },
        outlet: 'overlay',
      },
      {
        path: 'cloud',
        component: ImportExportComponent,
        outlet: 'overlay',
        children: [
          {
            path: 'indikatoren',
            component: ImportExportIndicatorsComponent,
            outlet: 'panel',
          },
          {
            path: 'daten',
            component: ImportExportDataComponent,
            outlet: 'panel',
          },
          {
            path: 'geo-daten',
            component: ImportExportGeodataComponent,
            outlet: 'panel',
          },
          {
            path: 'poi',
            component: ImportExportPoiComponent,
            outlet: 'panel',
          },
        ],
      },
      {
        path: 'sammel-aktionen',
        component: BulkActionsComponent,
        outlet: 'overlay',
        canActivate: [permissionGuard],
        data: { permission: 'massActions' },
        children: [
          {
            path: ':entity/:action',
            component: BulkActionComponent,
            outlet: 'aktion',
          },
        ],
      },
      {
        path: 'account',
        component: AccountComponent,
        outlet: 'overlay',
        children: [
          {
            path: 'tool-access',
            component: RoleToolsComponent,
            outlet: 'tab',
          },
          {
            path: 'indikator-access',
            component: RoleIndicatorsComponent,
            outlet: 'tab',
          },
          {
            path: 'raum-access',
            component: RoleDatalayerTypesComponent,
            outlet: 'tab',
          },
          {
            path: 'poi-access',
            component: RolePoisComponent,
            outlet: 'tab',
          },
          {
            path: 'lesezeichen-access',
            component: RoleBookmarksComponent,
            outlet: 'tab',
          },
        ],
      },
    ],
  },
  {
    path: 'atlas',
    component: AtlasComponent,
  },
  {
    path: ':slug',
    redirectTo: 'atlas/:slug',
    //pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];
